/**
 * Модель для работы ролями пользователей
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';


import UsersService, { IPermission } from '../services/UsersService';
import { ISecurableRight } from './types';

// tslint:disable-next-line: no-empty-interface
interface IState {
  data: ISecurableRight[];
}

const initialState: IState = {
  data: []
};

export const securable = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: ISecurableRight[]): IState {
      return { ...state, data: payload };
    },
    reset(): IState {
      return initialState;
    }
  },
  effects: () => ({
    async updateSecurableTree(config: any) {
      const { version: appVersion, root, securableTree } = config;

      try {
        const {
          data: { version: securableTreeVersion }
        } = await UsersService.getSecurableTreeVersion(root);

        if (appVersion > securableTreeVersion) {
          await UsersService.createSecurableTree(root, securableTree);
        }
      } catch (error) {
        return error;
      }
    },
    async getSecurables(config: any, rootState: any) {
      const { root } = config;
      try {
        const { data } = await UsersService.getCurrentUserPermissions(root);
        const mapped: ISecurableRight[] = (data as IPermission[]).map(p => ({
          id: p.id,
          uid: String(p.resourceId),
          action: p.action,
          result: p.access
        }));
        this.setData(mapped);
      } catch (error) {
        return error;
      }
    }
  })
});
